// extracted by mini-css-extract-plugin
export var link = "_tg-0";